import { render, staticRenderFns } from "./infoNot.vue?vue&type=template&id=218c2719&scoped=true&"
import script from "./infoNot.vue?vue&type=script&lang=js&"
export * from "./infoNot.vue?vue&type=script&lang=js&"
import style0 from "./infoNot.vue?vue&type=style&index=0&id=218c2719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c2719",
  null
  
)

export default component.exports